/**
 * `automation` translations, for every locale.
 *
 * The `trigger.*` and `selector.*` keys deliberately mirror values the SERVER
 * sends (`invoice_due_soon`, `ability`, …) rather than being free labels: the
 * page looks them up by key with the server's own text as the fallback, so a
 * trigger added in code appears immediately in English and gets its Mongolian
 * and Russian when somebody adds two lines here — instead of appearing as a
 * missing-key placeholder or, worse, not appearing at all.
 */
export const automation = {
  mn: {
    automation: {
      title: 'Автоматжуулалт',
      tabRules: 'Дүрмүүд', tabMessages: 'Илгээсэн захиа',
      rule: 'Дүрэм', rules: 'Дүрмүүд',
      enabled: 'Идэвхтэй', disabled: 'Идэвхгүй',
      builtin: 'Үндсэн', custom: 'Нэмэлт',
      leadTimes: 'Хугацаа (өдрөөр)',
      leadWindow: 'Хугацаа дуусахаас өмнөх энэ хоногт багтвал сануулна.',
      leadExact: 'Яг эдгээр хоногт сануулна (таслалаар тусгаарла).',
      leadNone: 'Энэ дүрэм үйл явдал дээр ажиллана — хугацаа шаардлагагүй.',
      to: 'Хэнд', cc: 'Хуулбар',
      addRecipient: 'Хүлээн авагч нэмэх',
      subject: 'Гарчиг', body: 'Агуулга',
      variables: 'Ашиглаж болох талбарууд',
      preview: 'Урьдчилан харах', previewing: 'Тооцоолж байна…',
      previewEmpty: 'Одоогоор хэн ч тохирохгүй байна: {{list}}',
      previewNobody: 'Энэ дүрэм хэнд ч хүрэхгүй тул юу ч илгээхгүй.',
      mailGapCount: 'Хүлээн авагч дутуу дүрэм: {{count}}. Мөр бүр дээр алийг нь бичсэн.',
      mailGapRow: 'Хүлээн авах хүн одоогоор алга: {{who}}.',
      mailGapSendsNothing: 'Энэ дүрэм юу ч илгээхгүй. Хүлээн авах хүн одоогоор алга: {{who}}.',
      customerMailbox: { hr_email: 'хүний нөөцийн түвшний бүх хүн', everyone_email: 'бүх ажилтан', management_email: 'гүйцэтгэх захирал ба санхүүгийн захирал' },
      customerLevel: '{{level}} түвшний бүх хүн',
      customerAbility: 'дараах эрхтэй хүн: {{ability}}',
      customerMailboxKind: 'Танай хүмүүсийн бүлэг',
      customerMailboxHelp: 'Энэ түвшин эсвэл бүлэгт шинээр орсон хүнд автоматаар хүрнэ. Бүх ажилтанд илгээх и-мэйл хүн бүрт тусад нь очих тул бусдын хаяг харагдахгүй.',
      saved: 'Хадгаллаа', deleted: 'Устгалаа',
      seedDefaults: 'Үндсэн дүрмүүдийг үүсгэх',
      seedAction: 'Үүсгэх', sendingTitle: 'Илгээлт',
      area: { time: 'Цаг ба бүртгэл', finance: 'Санхүү', hr: 'Хүний нөөц', other: 'Бусад' },
      kindLabel: 'Хэрхэн ажиллах',
      fireKind: { schedule: 'Хуваарийн дагуу', event: 'Үйлдэл хийгдэхэд' },
      loadSwitchesFailed: 'И-мэйлийн ерөнхий тохиргоо ачаалагдсангүй: {{message}}. Хуудсыг дахин ачаална уу; давтагдвал сервер ажиллаж байгаа эсэхийг шалгана уу.', loadRulesFailed: 'Автомат дүрмүүд ачаалагдсангүй: {{message}}. Хуудсыг дахин ачаална уу; давтагдвал сервер ажиллаж байгаа эсэхийг шалгана уу.', loadMessagesFailed: 'Илгээсэн захианы жагсаалт ачаалагдсангүй: {{message}}. Хуудсыг дахин ачаална уу.',
      switchBuiltIn: 'Суурь дүрэм хадгалагдаагүй: тохиргооны мөрөн дэх «Үүсгэх» товчийг дарсны дараа энд асааж унтраана.', seedHelp: 'Зарим автомат ажиллагаа хадгалагдаагүй суурь дүрмээр ажиллаж байна. «Үүсгэх» нь эдгээр дүрмийг хадгалж, засах болон асааж унтраах боломжтой болгоно.', switchFailed: 'Хадгалж чадсангүй: {{message}}', moreOptions: 'Нэмэлт тохиргоо', noChanges: 'Өөрчлөлт алга', duplicateRules: '{{count}} дүрэм: өгөгдлийн санд засна', duplicateHelp: 'Энэ автомат ажиллагаа нэгээс олон хадгалсан дүрэмтэй тул эндээс засах, турших, асааж унтраах боломжгүй. Өгөгдлийн санд нэгийг нь үлдээнэ үү.', leadTimesInvalid: 'Хоногийг тоогоор, таслалаар тусгаарлаж бичнэ үү, жишээ нь 7, 3, 1.', saveFailed: 'Дүрмийг хадгалж чадсангүй', previewFailed: 'Урьдчилан харах боломжгүй байна', noKindPicked: 'Дээрх хоёр шүүлтүүрийн нэгийг сонгоно уу.',
      mixedOn: 'Хэсэгчлэн',
      pausedExceptRequests: 'Хуваарьт и-мэйл унтарсан: дүрмүүд и-мэйл, мэдэгдэл илгээхгүй. Хүсэлтийн дүрэм ажиллана; OREAS, тоног төхөөрөмжийн хүсэлт зөвхөн мэдэгдэл үлдээнэ.',
      pausedChip: 'Зогссон', groupsLabel: 'Үйл явдлын бүлгүүд', groupAttention: 'Шалгах хэрэгтэй',
      previousPage: 'Өмнөх хуудас', nextPage: 'Дараагийн хуудас',
      seeded: '{{count}} дүрэм үүсгэлээ', seededNone: 'Бүх дүрэм аль хэдийн байна',
      noRules: 'Дүрэм алга',
      switchOn: 'Асаалттай', switchOff: 'Унтраалттай',
      switchTurnOn: 'Асаах', switchTurnOff: 'Унтраах',
      switchSaved: 'Хадгаллаа',
      scheduledTitle: 'Хуваарьт и-мэйл',
      scheduledOnHint: 'Доорх дүрмүүд и-мэйл, мэдэгдлээ илгээнэ. Унтраавал эдгээр нь (хэн нэгний үйлдлээс үүсэх и-мэйл, өдрийн тойм ч мөн) болон дараах ажлууд зогсоно: хугацаа хэтэрсэн баталгааг автоматаар татгалзах, амралтын үлдэгдлийг төлбөрт оруулах, жилийн эцсийн чөлөөний шинэчлэлт, шинэ цалингийн үе үүсгэх. Хүсэлтийн дүрэм ажилласаар байна; OREAS, тоног төхөөрөмжийн хүсэлт зөвхөн мэдэгдэл үлдээнэ. Нэвтрэх код, зочны урилга, ээлжийн амралтын олголт хэвийн.',
      scheduledOffHint:
        'Дүрмүүд и-мэйл, мэдэгдэл илгээхгүй, дараалалд ч оруулахгүй (хэн нэгний үйлдлээс үүсэх и-мэйл, өдрийн тойм ч мөн). Мөн зогссон: хугацаа хэтэрсэн баталгааг автоматаар татгалзах, амралтын үлдэгдлийг төлбөрт оруулах, жилийн эцсийн чөлөөний шинэчлэлт, шинэ цалингийн үе үүсгэх. Ажилласаар: хүсэлтийн дүрэм; OREAS, тоног төхөөрөмжийн хүсэлтийн мэдэгдэл; дараалалд орсон и-мэйл; нэвтрэх код, зочны урилга, ээлжийн амралтын олголт.',
      scheduledInert: 'Хуваарьт унтраалгаар зогсоосон',
      scheduledInertHint:
        'Дүрмүүдийг чөлөөтэй засаж болно — хуваарьт и-мэйл унтраалттай үед аль нь ч и-мэйл, мэдэгдэл илгээхгүй.',
      noticeOnlyHelp: 'Үүнийг унтраавал зөвхөн энэ мэдэгдэл зогсоно. Хуваарьт и-мэйл асаалттай бол шөнийн шалгалт өдрүүдийг татгалзсаар байна.',
      noticeOnlyOff: 'Мэдэгдэл унтарсан. Шөнийн шалгалт өдрүүдийг татгалзсаар байна.',
      triggeredTitle: 'Товч дарж илгээх и-мэйл',
      triggeredOnHint:
        'Цалингийн хуудас (сарын болон нэг удаагийн) илгээхэд ажилтан бүр рүү и-мэйл очно. Унтраавал зөвхөн энэ и-мэйл зогсоно.',
      triggeredOffHint:
        'Унтраалттай үед «Илгээх» товч ажиллана — цалингийн хуудас бэлдэнэ — гэхдээ сарын болон нэг удаагийн и-мэйл илгээгдэхгүй, дараалалд ч орохгүй бөгөөд дэлгэц дээр мэдэгдэнэ. Нэвтрэх код хэвийн ирнэ.',
      devModeTitle: 'Хөгжүүлэлтийн горим',
      devModeOnHint:
        'Бүх и-мэйл жинхэнэ хүлээн авагч руу биш, админ руу очно — тэдэнд юу ч очихгүй. И-мэйл бүр хэнд зориулагдсан, аль дүрмээр илгээгдсэнийг бичнэ.',
      devModeOffHint:
        'И-мэйл жинхэнэ хүлээн авагч руугаа очно. Бодит өгөгдөл дээр бодит дүрэм ажиллуулж, бүх и-мэйлийг зөвхөн админы шуудан руу авахыг хүсвэл асаана уу.',
      devModeIdle:
        'Хөгжүүлэлтийн горим асаалттай ч хуваарьт и-мэйл унтраалттай байна — тиймээс шилжүүлэх сануулга дараалалд орохгүй. Хуваарьт и-мэйлээ асаах, эсвэл дүрэм дээрх «Туршилт илгээх»-ийг ашиглана уу.',
      builtinLocked: 'Үндсэн дүрмийг устгах боломжгүй — идэвхгүй болгоно уу.',
      test: 'Тест', testHint: 'Энэ захиаг зөвхөн өөрийн хаяг руу жишээ өгөгдөлтэй илгээнэ. Дүрмийн жинхэнэ хүлээн авагчид руу очихгүй.', testSent: '{{address}} руу туршилтын захиа илгээлээ — “Илгээсэн захиа” хэсгээс харна.',
      confirmDelete: '“{{name}}” дүрмийг устгах уу?',
      // Messages
      status: 'Төлөв', kind: 'Төрөл', search: 'Хайх',
      searchHint: 'Гарчиг эсвэл хаягаар',
      allStatuses: 'Бүх төлөв', allKinds: 'Бүх төрөл',
      attempts: 'Оролдлого', sentAt: 'Илгээсэн', scheduledFor: 'Товлосон',
      lastError: 'Сүүлийн алдаа', deadLettered: 'Дахин оролдохгүй',
      deadLetteredCount: 'Дахин оролдохгүй: {{count}}',
      retry: 'Дахин илгээх', retried: 'Дараалалд буцаалаа',
      noMessages: 'Захиа алга',
      showing: 'Нийт {{total}}-аас {{count}}',
      openMessage: 'Захиа нээх',
      // Server-sent values
      trigger: {
        invoice_due_soon: 'Нэхэмжлэхийн хугацаа дөхөж байна',
        invoice_overdue: 'Нэхэмжлэхийн хугацаа хэтэрсэн',
        contract_end_soon: 'Гэрээ дуусах гэж байна',
        contract_end_past: 'Гэрээ дууссан',
        resignation_today: 'Ажлаас гарах өдөр болсон',
        hr_welcome: 'Шинэ ажилтныг угтах',
        hr_anniversary: 'Ажилласны ой',
        hr_birthday: 'Төрсөн өдөр',
        supervisor_changed: 'Шууд удирдлага өөрчлөгдсөн',
        staff_joined: 'Ажилтан ажилд орсон',
        staff_left: 'Ажилтан ажлаас гарсан',
        request_submitted: 'Хүсэлт ирлээ',
        request_decided: 'Хүсэлт шийдвэрлэгдлээ',
        equipment_request_decided: 'Тоног төхөөрөмжийн хүсэлтэд хариулсан',
        oreas_request_received: 'Нийтийн хуудаснаас OREAS хүсэлт ирсэн',
        oreas_request_resolved: 'OREAS хүсэлтээр ноорог үнийн санал гарсан',
        request_self_approved: 'Хүсэлтээ өөрөө баталсан',
        request_sent: 'Хүсэлт илгээгдлээ',
        timesheet_needs_approval: 'Дэд ажилтны цаг баталгаажуулах шаардлагатай',
        timesheet_rejected: 'Татгалзсан цагийн бүртгэл',
        timesheet_office_solo_late: 'Хоцорсон өдрийг Гүйцэтгэх захирал эсвэл Санхүүгийн захирал ганцаараа шийдсэн',
        timesheet_backlog_expired: 'Шөнийн хугацааны шалгалтаар автоматаар татгалзсан цагийн бүртгэлийн өдрүүд',
        timesheet_past_edit: 'Өнгөрсөн өдрийн цагийг цагийн админ зассан',
        timesheet_late_submitted: 'Цалингийн хаалтын огнооноос хойш батлуулахаар илгээсэн бүртгэл',
        salary_cutoff_pending: 'Хаагдахын өмнө илгээгээгүй цаг',
        salary_cutoff_last_day: 'Цаг оруулах сүүлийн өглөө (12:00-д хаагдана)',
        timesheet_pending_at_close: 'Хаагдах үед баталгаажаагүй өдрүүд (цагийн админ)',
        salary_cutoff_reminder: 'Цалингийн бодолт хаагдах өдөр дөхөж байна',
        timesheet_approval_deadline: 'Баталгаажуулах сүүлийн өдөр дэд ажилтны цагийг баталгаажуулах',
        timesheet_weekly_reminder: 'Долоо хоног тутмын цаг сануулга',
        annual_leave_unused: 'Ашиглаагүй ээлжийн амралт',
        leave_break_ending: 'Жирэмсний болон хүүхэд асрах чөлөө долоо хоногийн дараа дуусна',
        leave_break_starting: 'Жирэмсний болон хүүхэд асрах чөлөө батлагдсан: ажилтан завсарлагаанд гарна',
        leave_approval_pending: 'Батлагдаагүй чөлөөний хүсэлт',
        leave_submitted: 'Чөлөөний хүсэлт ирлээ',
        leave_decided: 'Чөлөөний хүсэлт шийдвэрлэгдлээ',
        overwork_14_days: '14 хоног амралтгүй ажилласан',
      },
      selector: {
        ability: 'Эрх бүхий хүн бүр', level: 'Тухайн түвшний хүн бүр', role: 'Албан тушаалын бичвэр',
        email: 'Яг нэг хаяг', setting: 'Нийтийн шуудан', subject: 'Хамаарал бүхий хүн',
        subjectRecipient: 'Мэдэгдэл авах хүмүүс', subjectEmployee: 'Ажилтан өөрөө', subjectSupervisor: 'Шинэ удирдагч',
      },
      selectorHelp: {
        ability:
          'Тухайн хүн юу хийх эрхтэйг асууна. Түвшний нэр өөрчлөгдсөн ч ажиллана. Админ үргэлж тохирно. Ихэвчлэн энэ нь зөв сонголт.',
        level:
          'Аль хандах түвшинд байгааг асууна. Эрх нь хэтэрхий олон хүнд байвал үүнийг ашигла.',
        role:
          'SharePoint-оос орж ирсэн албан тушаалын бичвэр. Анхдагч утга нь “Finance” тул ихэнх бүртгэл сонгуулгүйгээр тэр утгатай байдаг — тоог нь шалгаад ашигла.',
        email: 'Гараар бичсэн нэг хаяг. Хүн ажлаа сольвол дагахгүй.',
        setting: 'Апп-д тохируулсан нийтийн шуудан, жишээ нь hr@ эсвэл everyone@.',
        subject: 'Захианд хамаарах хүн — захиа бүрт өөр хүн болно.',
      },
      goesTo: 'Одоо очих:', alsoCopies: 'Хуулбар очих:',
      perMessage: '(тухай бүрт өөр)',
      reachNobody: '— хэн ч алга',
      reachSome: '— {{count}}',
      reachMost: '— {{total}}-аас {{count}}, бараг бүгд',
      usingBuiltIn: 'Хадгалсан дүрэм алга тул үндсэн дүрэм ажиллаж, захиа илгээсээр байна.',
      builtInOff:
        'Хадгалсан дүрэм алга, үндсэн дүрэм анхнаасаа УНТРААЛТТАЙ: дүрэм хадгалж асаах хүртэл юу ч илгээгдэхгүй.',
      source: {
        invoices: 'Нэхэмжлэхийн хугацаа',
        celebrations: 'Төрсөн өдөр ба ой',
        contracts: 'Гэрээ ба ажлаас гарах',
        immediate: 'Хувийн хэргийн өөрчлөлт',
        requests: 'Хүсэлтүүд',
        timesheets: 'Өдөр тутмын цагийн бүртгэл',
        salaryCutoff: 'Цалингийн тасалбар өдөр',
        weeklyReminder: 'Долоо хоног тутмын цаг сануулга',
        annualLeave: 'Ээлжийн амралт',
        leave: 'Чөлөөний хүсэлтүүд',
        rest: 'Амралт, завсарлага',
        rosterDepartures: 'Ээлжид гарах огноо',
        approvalBacklog: 'Хүлээгдэж буй батлалт',
        equipmentRequests: 'Тоног төхөөрөмжийн хүсэлт',
      },
      help: {
        title: 'Энэ хуудас хэрхэн ажилладаг вэ',
        what:
          'Доорх карт бүр нь “болзол” — апп-ын ажигладаг үйл явдал, жишээ нь нэхэмжлэхийн хугацаа хэтрэх. Болзол хэзээ биелэхийг апп шийднэ; та түүнд юу хийхийг шийднэ: хэнд илгээх, хэдэн хоногийн өмнө, ямар үгтэй. Дүрмийг нээж эдгээрийг өөрчилнө. Захиаг зогсоохын тулд дүрмийг идэвхгүй болго — үндсэн дүрмийг устгаж болохгүй, учир нь сүүлчийнхийг устгавал анхны хувилбар нь эргэж ажиллана.',
        fromTitle: 'Хаанаас илгээгддэг вэ',
        transport: { graph: 'Microsoft 365-ээр', smtp: 'SMTP дамжуулагчаар' },
        replies: 'Энэ бол хариу авдаггүй (no-reply) хаяг — хүлээн авагчийн бичсэн хариуг хэн ч уншихгүй. Тиймээс хариу шаардсан захиа бичих бол хэнд хандахыг захианы бие дотор нэрлэж өгөх ёстой. Илгээгчийн хаягийг серверийн тохиргоо (MAIL_SENDER) заадаг тул энэ хуудаснаас өөрчлөгдөхгүй.',
        whenTitle: 'Хэзээ шалгагддаг вэ',
        when: {
          invoices: { time: 'Ажлын өдөр 08:00', what: 'хугацаа дөхсөн ба хэтэрсэн нэхэмжлэх' },
          celebrations: { time: 'Өдөр бүр 09:00', what: 'төрсөн өдөр, шинэ ажилтан, ажилласны ой' },
          contracts: { time: 'Өдөр бүр 10:00', what: 'гэрээ дуусах/дууссан, ажлаас гарах огноо' },
          immediate: { time: 'Тэр даруй', what: 'шууд удирдлага солигдохыг HR хадгалахад' },
          requests: { time: 'Тэр даруй', what: 'хүсэлт ирэх, зөвшөөрөгдөх эсвэл татгалзагдах үед' },
          timesheets: { time: 'Өдөр бүр 10:00', what: 'баталгаажуулах шаардлагатай эсвэл татгалзсан цагийн бүртгэл' },
          salaryCutoff: { time: 'Өдөр бүр 10:00 ба 15:00', what: 'цалингийн бодолт хаагдахын өмнөх сануулга ба баталгаажуулах хугацаа' },
          weeklyReminder: { time: 'Баасан гараг 15:00', what: 'цаг болон дараа долоо хоногийн төлөвлөгөөгөө бөглөх сануулга' },
          annualLeave: { time: 'Сар бүр (8-р сараас хойш)', what: 'ашиглаагүй ээлжийн амралттай ажилтнууд' },
          leave: { time: 'Тэр даруй, мөн өдөр бүр', what: 'чөлөөний хүсэлт ирэх, шийдвэрлэгдэх, мөн зөвшөөрөл хүлээгдэж буй хүсэлтийг өдөр бүр сануулах' },
          rest: { time: '3 өдөр тутам 14:00', what: '14 хоног амралтгүй ажилласан ажилтан' },
          rosterDepartures: { time: 'Өдөр бүр 11:00', what: 'ээлжид 7, 4, 1 хоногийн дараа гарах ажилтан' },
        },
        notScheduling:
          'Эдгээр цаг тогтмол бөгөөд энэ хуудаснаас тохируулагдахгүй. Дараа нь захиа хагас минутын дотор явна; бодитоор юу явсныг “Илгээсэн захиа” хэсгээс харна.',
        reach:
          'Дүрэм бүр одоо хэнд хүрэхийг харуулна. Хаягуудыг харахын тулд бүлгээ дар. Шар өнгө нь компанийн ихэнхэд хүрч байгааг заана — төрсөн өдөрт тохиромжтой, бусад тохиолдолд дахин шалгах нь зүйтэй.',
      },
      statusValue: { Pending: 'Хүлээгдэж буй', Sending: 'Илгээж байна', Sent: 'Илгээсэн', Failed: 'Амжилтгүй' },
    },
  },
  en: {
    automation: {
      title: 'Automation',
      tabRules: 'Rules', tabMessages: 'Messages',
      rule: 'Rule', rules: 'Rules',
      enabled: 'On', disabled: 'Off',
      builtin: 'Built-in', custom: 'Custom',
      leadTimes: 'Lead times (days)',
      leadWindow: 'Warns once the date is within this many days.',
      leadExact: 'Warns only on these exact days ahead (comma separated).',
      leadNone: 'This rule fires on an event, so it takes no lead times.',
      to: 'To', cc: 'Cc',
      addRecipient: 'Add recipient',
      subject: 'Subject', body: 'Body',
      variables: 'Available fields',
      preview: 'Preview', previewing: 'Resolving…',
      previewEmpty: 'Matches nobody right now: {{list}}',
      previewNobody: 'This rule reaches nobody, so it would send nothing.',
      mailGapCount: 'Rules missing a recipient: {{count}}. Each row says which.',
      mailGapRow: 'Nobody is there to receive this yet: {{who}}.',
      mailGapSendsNothing: 'This rule sends nothing. Nobody is there to receive it yet: {{who}}.',
      customerMailbox: { hr_email: 'everyone on the HR level', everyone_email: 'everyone in the company', management_email: 'the CEO and the CFO' },
      customerLevel: 'everyone on the {{level}} level',
      customerAbility: 'anyone who may: {{ability}}',
      customerMailboxKind: 'A group of your people',
      customerMailboxHelp: 'It follows whoever joins the level or the company. Mail to everyone goes to each person separately, so nobody sees the other addresses.',
      saved: 'Saved', deleted: 'Deleted',
      seedDefaults: 'Create the built-in rules',
      seedAction: 'Create', sendingTitle: 'Sending',
      area: { time: 'Time & logs', finance: 'Finance', hr: 'HR', other: 'Other' },
      kindLabel: 'How it fires',
      fireKind: { schedule: 'On schedule', event: 'When something happens' },
      loadSwitchesFailed: 'The email switches did not load: {{message}}. Reload the page; if it keeps failing, check the backend is running.', loadRulesFailed: 'The automation rules did not load: {{message}}. Reload the page; if it keeps failing, check the backend is running.', loadMessagesFailed: 'The sent-mail list did not load: {{message}}. Reload the page.',
      switchBuiltIn: 'Built-in rule, not saved yet: press Create beside the switches to switch it here.', seedHelp: 'Some automations run on a built-in rule that is not saved yet. Create saves those rules so they can be edited and switched on or off.', switchFailed: 'Not saved: {{message}}', moreOptions: 'More options', noChanges: 'Nothing has changed yet', duplicateRules: '{{count}} rules: fix in the database', duplicateHelp: 'This automation has more than one saved rule, so it cannot be edited, tested or switched here. Keep one of them in the database.', leadTimesInvalid: 'Enter days as numbers separated by commas, for example 7, 3, 1.', saveFailed: 'Could not save the rule', previewFailed: 'Could not build the preview', noKindPicked: 'Tick at least one of the two filters above.',
      mixedOn: 'Partly on',
      pausedExceptRequests: 'Scheduled email is off: rules send no mail or notices. Request rules still send; OREAS and equipment requests keep their notices only.',
      pausedChip: 'Paused', groupsLabel: 'Trigger groups', groupAttention: 'Needs a look',
      previousPage: 'Previous page', nextPage: 'Next page',
      seeded: 'Created {{count}} rule(s)', seededNone: 'Every rule already exists',
      noRules: 'No rules yet',
      switchOn: 'On', switchOff: 'Off',
      switchTurnOn: 'Turn on', switchTurnOff: 'Turn off',
      switchSaved: 'Saved',
      scheduledTitle: 'Scheduled email',
      scheduledOnHint: "The rules below send their mail and notices. Turning this off stops them (mail raised by someone's action and the daily summary too) and these jobs: rejecting overdue approvals, queuing break leave for payout, the year-end leave reset, adding pay periods. Request rules still send; OREAS and equipment requests keep their notices only. Sign-in codes, guest invitations and leave grants carry on.",
      scheduledOffHint:
        "Rules send and queue no mail or notices (mail raised by someone's action and the daily summary too). Also stopped: rejecting overdue approvals, queuing break leave for payout, the year-end leave reset, adding pay periods. Still running: request rules; OREAS and equipment notices; mail already queued; sign-in codes, guest invitations and leave grants.",
      scheduledInert: 'Paused by the scheduled switch',
      scheduledInertHint:
        'Edit rules freely — none of them sends mail or a notice while scheduled email is off.',
      noticeOnlyHelp: 'Turning this off stops this notice only. While Scheduled email is on, the nightly expiry still rejects the days.',
      noticeOnlyOff: 'Notice off. The nightly expiry still rejects the days.',
      triggeredTitle: 'Email sent by a button',
      triggeredOnHint:
        'Sending payslips, monthly or one-off, e-mails each person. Turning this off stops only that mail.',
      triggeredOffHint:
        'While this is off, Send still works — the payslip run completes — but no e-mail, monthly or one-off, is sent or queued, and the page says so. Sign-in codes still arrive.',
      devModeTitle: 'Dev mode',
      devModeOnHint:
        'Every message goes to the administrators instead of the people it was written for — they receive nothing. Each one says who it was for and which rule sent it.',
      devModeOffHint:
        'Mail goes to its real recipients. Turn this on to fire real rules against real data and have every message land in the administrators’ inbox instead.',
      devModeIdle:
        'Dev mode is on, but scheduled email is off — so no reminder is being queued for it to redirect. Turn scheduled email on, or use Send test on a rule.',
      builtinLocked: 'A built-in rule cannot be deleted — switch it off instead.',
      test: 'Send test', testHint: 'Sends this message to your own address with sample data. It never goes to the rule’s real recipients.', testSent: 'Test sent to {{address}} — it will appear under Messages.',
      confirmDelete: 'Delete the rule “{{name}}”?',
      // Messages
      status: 'Status', kind: 'Kind', search: 'Search',
      searchHint: 'Subject or address',
      allStatuses: 'All statuses', allKinds: 'All kinds',
      attempts: 'Attempts', sentAt: 'Sent', scheduledFor: 'Scheduled',
      lastError: 'Last error', deadLettered: 'No further retry',
      deadLetteredCount: 'Dead-lettered: {{count}}',
      retry: 'Retry', retried: 'Put back in the queue',
      noMessages: 'Nothing sent yet',
      showing: '{{count}} of {{total}}',
      openMessage: 'Open message',
      // Server-sent values
      trigger: {
        invoice_due_soon: 'Invoice due soon',
        invoice_overdue: 'Invoice overdue',
        contract_end_soon: 'Contract ending',
        contract_end_past: 'Contract ended',
        resignation_today: 'Resignation date reached',
        hr_welcome: 'Welcome (first year)',
        hr_anniversary: 'Work anniversary',
        hr_birthday: 'Birthday',
        supervisor_changed: 'Supervisor changed',
        staff_joined: 'Employee joined',
        staff_left: 'Employee left',
        request_submitted: 'Request submitted',
        request_decided: 'Request approved or rejected',
        equipment_request_decided: 'Equipment request resolved or rejected',
        oreas_request_received: 'OREAS request from the public page',
        oreas_request_resolved: 'OREAS request became a Draft quotation',
        request_self_approved: 'Request self-approved',
        request_sent: 'Request sent',
        timesheet_needs_approval: 'Supervisees need timesheet approval',
        timesheet_rejected: 'Rejected timesheet logs',
        timesheet_office_solo_late: 'Late day decided by the CEO or CFO alone',
        timesheet_backlog_expired: 'Timesheet days rejected automatically by the nightly expiry',
        timesheet_past_edit: 'Past day corrected by a time admin',
        timesheet_late_submitted: 'Log sent for approval after the payroll cut-off',
        salary_cutoff_pending: 'Hours still to send before cut-off',
        salary_cutoff_last_day: 'Last morning to send hours (entry closes at 12:00)',
        timesheet_pending_at_close: 'Days still pending at the close (time admins)',
        salary_cutoff_reminder: 'Payroll cut-off is approaching',
        timesheet_approval_deadline: 'Approve supervisee days on the last approval day',
        timesheet_weekly_reminder: 'Weekly reminder to log time',
        annual_leave_unused: 'Unused annual leave',
        leave_break_ending: 'Maternity or child-care break ends in a week',
        leave_break_starting: 'Maternity or child-care leave approved: the person goes on break',
        leave_approval_pending: 'Leave applications waiting on approval',
        leave_submitted: 'Leave request submitted',
        leave_decided: 'Leave request decided',
        overwork_14_days: 'No day off in 14 days',
      },
      selector: {
        ability: 'Anyone who may…', level: 'Anyone on the level', role: 'Anyone whose job title is',
        email: 'One exact address', setting: 'A shared mailbox', subject: 'The person it is about',
        subjectRecipient: 'The people it tells', subjectEmployee: 'The employee', subjectSupervisor: 'Their new supervisor',
      },
      // What each kind actually asks. Without these, "By role" and "By access
      // level" read as the same choice worded twice.
      selectorHelp: {
        ability:
          'Asks what somebody is allowed to do, so it keeps working when levels are renamed. Administrators always match. Usually the right choice.',
        level:
          'Asks which access level somebody sits on. Use it when an ability is held by more people than you mean.',
        role:
          'The job-title text imported from SharePoint. It defaults to “Finance”, so most accounts carry that value without anybody choosing it — check the count before relying on it.',
        email: 'One address, typed in. It does not follow people when they change job.',
        setting: 'A shared mailbox configured for the whole app, such as hr@ or everyone@.',
        subject: 'Whoever the message concerns — filled in per message, so it is a different person each time.',
      },
      goesTo: 'Emails now:', alsoCopies: 'Copies in:',
      perMessage: '(different each time)',
      reachNobody: '— nobody',
      reachSome: '— {{count}}',
      // The two numbers side by side. This is the line that makes a rule
      // addressed to the whole company look different from one that is not.
      reachMost: '— {{count}} of {{total}}, nearly everyone',
      usingBuiltIn: 'No rule saved, so the built-in one is used. It is still sending.',
      builtInOff:
        'No rule saved, and the built-in one starts OFF: nothing is sent until a rule is saved and switched on.',
      source: {
        invoices: 'Invoice due dates',
        celebrations: 'Birthdays & anniversaries',
        contracts: 'Contracts & leaving',
        immediate: 'Changes to a personnel record',
        requests: 'Requests',
        timesheets: 'Daily timesheets',
        salaryCutoff: 'Salary cut-off',
        weeklyReminder: 'Weekly timesheet reminder',
        annualLeave: 'Annual leave',
        leave: 'Leave applications',
        rest: 'Rest and breaks',
        rosterDepartures: 'Roster departures',
        approvalBacklog: 'Approval backlog',
        equipmentRequests: 'Equipment requests',
      },
      help: {
        title: 'How this page works',
        what:
          'Each card below is a trigger — something the app watches for, such as an invoice passing its due date. The app decides when a trigger happens; you decide what it does about it: who is emailed, how far ahead, and the exact wording. Open a rule to change any of that. To stop a message, switch its rule off — built-in rules cannot be deleted, because deleting the last one would bring the original back rather than stop the mail.',
        fromTitle: 'Where it sends from',
        transport: { graph: 'via Microsoft 365', smtp: 'via an SMTP relay' },
        replies: 'This is a no-reply address — nobody reads what a recipient sends back. So if a rule asks someone to respond, its message must name a real person or address in the body. The sender is server configuration (MAIL_SENDER) and cannot be changed from this page.',
        whenTitle: 'When they are checked',
        when: {
          invoices: { time: 'Weekdays 08:00', what: 'invoices due soon and overdue' },
          celebrations: { time: 'Every day 09:00', what: 'birthdays, welcomes and work anniversaries' },
          contracts: { time: 'Every day 10:00', what: 'contracts ending or ended, resignation dates' },
          immediate: { time: 'Straight away', what: 'a supervisor change, when HR saves it' },
          requests: { time: 'Straight away', what: 'a request raised, approved or rejected' },
          timesheets: { time: 'Every day 10:00', what: 'logs needing approval, and rejected logs' },
          salaryCutoff: { time: 'Every day 10:00 & 15:00', what: 'unapproved hours and the approval deadline before payroll closes' },
          weeklyReminder: { time: 'Fridays 15:00', what: 'a reminder to log hours and next week’s plan' },
          annualLeave: { time: 'Monthly, from August', what: 'staff sitting on unused annual leave' },
          leave: { time: 'Straight away, and daily', what: 'a leave request raised or decided, and a daily chase while one is still waiting on an approval' },
          rest: { time: 'Every few days at 14:00', what: 'an employee with no day off in 14 days' },
          rosterDepartures: { time: 'Every day 11:00', what: 'roster departures due in 7, 4 or 1 days' },
        },
        notScheduling:
          'These times are fixed and are not set on this page. Mail then leaves within about half a minute; the Messages tab shows what actually went out.',
        reach:
          'Every rule shows who it reaches right now. Click a recipient group to see the addresses. Amber means it reaches most of the company — right for a birthday, worth a second look on anything else.',
      },
      statusValue: { Pending: 'Pending', Sending: 'Sending', Sent: 'Sent', Failed: 'Failed' },
    },
  },
  ru: {
    automation: {
      title: 'Автоматизация',
      tabRules: 'Правила', tabMessages: 'Сообщения',
      rule: 'Правило', rules: 'Правила',
      enabled: 'Вкл', disabled: 'Выкл',
      builtin: 'Встроенное', custom: 'Своё',
      leadTimes: 'Заблаговременность (дни)',
      leadWindow: 'Предупреждает, когда до даты остаётся не больше стольких дней.',
      leadExact: 'Предупреждает ровно за столько дней (через запятую).',
      leadNone: 'Это правило срабатывает по событию, дни не нужны.',
      to: 'Кому', cc: 'Копия',
      addRecipient: 'Добавить получателя',
      subject: 'Тема', body: 'Текст',
      variables: 'Доступные поля',
      preview: 'Предпросмотр', previewing: 'Вычисляем…',
      previewEmpty: 'Сейчас никому не соответствует: {{list}}',
      previewNobody: 'Правило никого не охватывает и ничего не отправит.',
      mailGapCount: 'Правил, где не хватает получателя: {{count}}. В каждой строке указано, какого.',
      mailGapRow: 'Получателей пока нет: {{who}}.',
      mailGapSendsNothing: 'Правило ничего не отправит. Получателей пока нет: {{who}}.',
      customerMailbox: { hr_email: 'все на уровне отдела кадров', everyone_email: 'все сотрудники компании', management_email: 'генеральный и финансовый директора' },
      customerLevel: 'все на уровне {{level}}',
      customerAbility: 'все, кому разрешено: {{ability}}',
      customerMailboxKind: 'Группа ваших сотрудников',
      customerMailboxHelp: 'Группа сама учитывает новых людей на уровне или в компании. Письмо всем уходит каждому отдельно, поэтому чужие адреса никто не видит.',
      saved: 'Сохранено', deleted: 'Удалено',
      seedDefaults: 'Создать встроенные правила',
      seedAction: 'Создать', sendingTitle: 'Отправка',
      area: { time: 'Время и табели', finance: 'Финансы', hr: 'Кадры', other: 'Прочее' },
      kindLabel: 'Как срабатывает',
      fireKind: { schedule: 'По расписанию', event: 'При событии' },
      loadSwitchesFailed: 'Переключатели почты не загрузились: {{message}}. Перезагрузите страницу; если ошибка повторяется, проверьте, что сервер запущен.', loadRulesFailed: 'Правила автоматизации не загрузились: {{message}}. Перезагрузите страницу; если ошибка повторяется, проверьте, что сервер запущен.', loadMessagesFailed: 'Список отправленных писем не загрузился: {{message}}. Перезагрузите страницу.',
      switchBuiltIn: 'Встроенное правило ещё не сохранено: нажмите «Создать» рядом с переключателями, чтобы переключать его здесь.', seedHelp: 'Часть автоматизаций работает по встроенному правилу, которое ещё не сохранено. «Создать» сохраняет эти правила, чтобы их можно было изменять и включать или выключать.', switchFailed: 'Не сохранено: {{message}}', moreOptions: 'Дополнительно', noChanges: 'Изменений пока нет', duplicateRules: 'Правил: {{count}} — исправьте в базе данных', duplicateHelp: 'У этой автоматизации больше одного сохранённого правила, поэтому её нельзя изменить, проверить или переключить здесь. Оставьте одно из них в базе данных.', leadTimesInvalid: 'Введите дни числами через запятую, например 7, 3, 1.', saveFailed: 'Не удалось сохранить правило', previewFailed: 'Не удалось построить предпросмотр', noKindPicked: 'Отметьте хотя бы один из двух фильтров выше.',
      mixedOn: 'Частично',
      pausedExceptRequests: 'Почта по расписанию выключена: правила не отправляют ни писем, ни уведомлений. Правила заявок работают; для заявок OREAS и на оборудование остаются только уведомления.',
      pausedChip: 'Остановлено', groupsLabel: 'Группы событий', groupAttention: 'Нужно проверить',
      previousPage: 'Предыдущая страница', nextPage: 'Следующая страница',
      seeded: 'Создано правил: {{count}}', seededNone: 'Все правила уже существуют',
      noRules: 'Правил пока нет',
      switchOn: 'Включено', switchOff: 'Выключено',
      switchTurnOn: 'Включить', switchTurnOff: 'Выключить',
      switchSaved: 'Сохранено',
      scheduledTitle: 'Почта по расписанию',
      scheduledOnHint: 'Правила ниже отправляют письма и уведомления. Выключение останавливает их (включая письма по чьему-то действию и ежедневную сводку) и эти задачи: отклонение просроченных согласований, постановку отпуска при перерыве на выплату, сброс отпусков в конце года, добавление расчётных периодов. Правила заявок работают; для заявок OREAS и на оборудование остаются только уведомления. Коды входа, гостевые приглашения и начисление отпуска продолжаются.',
      scheduledOffHint:
        'Правила не отправляют и не ставят в очередь ни писем, ни уведомлений (включая письма по чьему-то действию и ежедневную сводку). Также остановлены: отклонение просроченных согласований, постановка отпуска при перерыве на выплату, сброс отпусков в конце года, добавление расчётных периодов. Работают: правила заявок; уведомления о заявках OREAS и на оборудование; письма уже в очереди; коды входа, гостевые приглашения и начисление отпуска.',
      scheduledInert: 'Остановлено переключателем расписания',
      scheduledInertHint:
        'Правила можно редактировать — пока почта по расписанию выключена, ни одно из них не отправляет ни писем, ни уведомлений.',
      noticeOnlyHelp: 'Выключение останавливает только это уведомление. Пока почта по расписанию включена, ночная проверка продолжает отклонять дни.',
      noticeOnlyOff: 'Уведомление выключено. Ночная проверка продолжает отклонять дни.',
      triggeredTitle: 'Почта по нажатию кнопки',
      triggeredOnHint:
        'Отправка расчётных листков, ежемесячных и разовых, отправляет письмо каждому сотруднику. Выключение останавливает только эти письма.',
      triggeredOffHint:
        'Пока выключено, «Отправить» работает — расчёт завершается — но письма, ежемесячные и разовые, не отправляются и не ставятся в очередь, и страница об этом сообщает. Коды входа приходят по-прежнему.',
      devModeTitle: 'Режим разработки',
      devModeOnHint:
        'Каждое письмо уходит администраторам, а не тем, кому оно написано — те не получают ничего. В каждом указано, кому оно предназначалось и какое правило его отправило.',
      devModeOffHint:
        'Письма уходят настоящим получателям. Включите, чтобы запускать реальные правила на реальных данных, а все письма получать в почту администраторов.',
      devModeIdle:
        'Режим разработки включён, но почта по расписанию выключена — значит, напоминания не ставятся в очередь и перенаправлять нечего. Включите почту по расписанию или используйте «Отправить тест» у правила.',
      builtinLocked: 'Встроенное правило нельзя удалить — отключите его.',
      test: 'Тест', testHint: 'Отправляет это письмо на ваш адрес с примерными данными. Настоящие получатели правила его не получат.', testSent: 'Тестовое письмо отправлено на {{address}} — оно появится в разделе «Сообщения».',
      confirmDelete: 'Удалить правило «{{name}}»?',
      // Messages
      status: 'Статус', kind: 'Тип', search: 'Поиск',
      searchHint: 'Тема или адрес',
      allStatuses: 'Все статусы', allKinds: 'Все типы',
      attempts: 'Попытки', sentAt: 'Отправлено', scheduledFor: 'Запланировано',
      lastError: 'Последняя ошибка', deadLettered: 'Повторов не будет',
      deadLetteredCount: 'Без повторов: {{count}}',
      retry: 'Повторить', retried: 'Возвращено в очередь',
      noMessages: 'Пока ничего не отправлено',
      showing: '{{count}} из {{total}}',
      openMessage: 'Открыть сообщение',
      // Server-sent values
      trigger: {
        invoice_due_soon: 'Скоро срок оплаты счёта',
        invoice_overdue: 'Счёт просрочен',
        contract_end_soon: 'Договор заканчивается',
        contract_end_past: 'Договор закончился',
        resignation_today: 'Наступила дата увольнения',
        hr_welcome: 'Приветствие новому сотруднику',
        hr_anniversary: 'Годовщина работы',
        hr_birthday: 'День рождения',
        supervisor_changed: 'Смена руководителя',
        staff_joined: 'Сотрудник принят',
        staff_left: 'Сотрудник уволился',
        request_submitted: 'Заявка подана',
        request_decided: 'Заявка одобрена или отклонена',
        equipment_request_decided: 'Ответ на заявку на оборудование',
        oreas_request_received: 'Заявка OREAS с публичной страницы',
        oreas_request_resolved: 'По заявке OREAS создан черновик предложения',
        request_self_approved: 'Заявка утверждена самим заявителем',
        request_sent: 'Заявка отправлена',
        timesheet_needs_approval: 'Подчинённым нужно подтверждение табеля',
        timesheet_rejected: 'Отклонённые записи табеля',
        timesheet_office_solo_late: 'Просроченный день решён генеральным или финансовым директором единолично',
        timesheet_backlog_expired: 'Дни табеля, автоматически отклонённые ночной проверкой сроков',
        timesheet_past_edit: 'Прошедший день исправлен администратором времени',
        timesheet_late_submitted: 'Запись отправлена на утверждение после даты отсечки зарплаты',
        salary_cutoff_pending: 'Неотправленные часы перед закрытием',
        salary_cutoff_last_day: 'Последнее утро для отправки часов (ввод закрывается в 12:00)',
        timesheet_pending_at_close: 'Неутверждённые дни на момент закрытия (администраторы времени)',
        salary_cutoff_reminder: 'Приближается закрытие расчёта зарплаты',
        timesheet_approval_deadline: 'Утвердить дни подчинённых в последний день утверждения',
        timesheet_weekly_reminder: 'Еженедельное напоминание о табеле',
        annual_leave_unused: 'Неиспользованный ежегодный отпуск',
        leave_break_ending: 'Декретный отпуск или отпуск по уходу за ребёнком заканчивается через неделю',
        leave_break_starting: 'Декретный отпуск или отпуск по уходу за ребёнком одобрен: сотрудник уходит в перерыв',
        leave_approval_pending: 'Заявки на отпуск ждут подтверждения',
        leave_submitted: 'Заявка на отпуск подана',
        leave_decided: 'Заявка на отпуск решена',
        overwork_14_days: 'Без выходного 14 дней подряд',
      },
      selector: {
        ability: 'Все, кому можно…', level: 'Все на уровне доступа', role: 'Все с должностью',
        email: 'Один точный адрес', setting: 'Общий ящик', subject: 'Тот, о ком письмо',
        subjectRecipient: 'Те, кому сообщают', subjectEmployee: 'Сам сотрудник', subjectSupervisor: 'Новый руководитель',
      },
      selectorHelp: {
        ability:
          'Спрашивает, что человеку разрешено делать, и переживает переименование уровней. Администраторы подходят всегда. Обычно это верный выбор.',
        level:
          'Спрашивает, на каком уровне доступа человек находится. Берите, когда право есть у большего числа людей, чем нужно.',
        role:
          'Текст должности, импортированный из SharePoint. Значение по умолчанию — «Finance», поэтому большинство учётных записей несёт его без чьего-либо решения; сверьтесь с числом, прежде чем полагаться.',
        email: 'Один адрес, введённый вручную. Он не следует за человеком при смене работы.',
        setting: 'Общий ящик, настроенный для всего приложения, например hr@ или everyone@.',
        subject: 'Тот, кого касается письмо, — подставляется в каждом письме, поэтому каждый раз другой человек.',
      },
      goesTo: 'Уйдёт сейчас:', alsoCopies: 'В копии:',
      perMessage: '(каждый раз разный)',
      reachNobody: '— никому',
      reachSome: '— {{count}}',
      reachMost: '— {{count}} из {{total}}, почти все',
      usingBuiltIn: 'Правило не сохранено, поэтому работает встроенное. Письма всё равно уходят.',
      builtInOff:
        'Правило не сохранено, а встроенное по умолчанию ВЫКЛЮЧЕНО: ничего не отправляется, пока правило не сохранят и не включат.',
      source: {
        invoices: 'Сроки оплаты счетов',
        celebrations: 'Дни рождения и годовщины',
        contracts: 'Договоры и увольнения',
        immediate: 'Изменения в личном деле',
        requests: 'Заявки',
        timesheets: 'Ежедневные табели',
        salaryCutoff: 'Отсечка по зарплате',
        weeklyReminder: 'Еженедельное напоминание о табеле',
        annualLeave: 'Ежегодный отпуск',
        leave: 'Заявки на отпуск',
        rest: 'Отдых и перерывы',
        rosterDepartures: 'Выезд на вахту',
        approvalBacklog: 'Очередь на утверждение',
        equipmentRequests: 'Заявки на оборудование',
      },
      help: {
        title: 'Как устроена эта страница',
        what:
          'Каждая карточка ниже — это событие, за которым следит приложение, например счёт, у которого прошёл срок оплаты. Когда событие наступит, решает приложение; что с ним делать, решаете вы: кому написать, за сколько дней и какими словами. Откройте правило, чтобы это изменить. Чтобы прекратить письма, выключите правило — встроенные нельзя удалить, потому что удаление последнего вернёт исходное, а не остановит рассылку.',
        fromTitle: 'Откуда отправляется',
        transport: { graph: 'через Microsoft 365', smtp: 'через SMTP-релей' },
        replies: 'Это адрес no-reply — ответы получателей никто не читает. Поэтому если правило просит ответить, в тексте письма должен быть указан реальный человек или адрес. Отправитель задаётся конфигурацией сервера (MAIL_SENDER) и не меняется с этой страницы.',
        whenTitle: 'Когда выполняется проверка',
        when: {
          invoices: { time: 'Будни 08:00', what: 'счета с близким сроком и просроченные' },
          celebrations: { time: 'Ежедневно 09:00', what: 'дни рождения, приветствия и годовщины' },
          contracts: { time: 'Ежедневно 10:00', what: 'договоры на исходе и истёкшие, даты увольнения' },
          immediate: { time: 'Сразу же', what: 'смена руководителя, когда её сохраняет HR' },
          requests: { time: 'Сразу же', what: 'подача заявки, её одобрение или отклонение' },
          timesheets: { time: 'Ежедневно 10:00', what: 'записи, требующие подтверждения, и отклонённые записи' },
          salaryCutoff: { time: 'Ежедневно 10:00 и 15:00', what: 'неподтверждённые часы и срок подтверждения перед закрытием расчёта' },
          weeklyReminder: { time: 'По пятницам 15:00', what: 'напоминание внести часы и план на следующую неделю' },
          annualLeave: { time: 'Ежемесячно (с августа)', what: 'сотрудники с неиспользованным ежегодным отпуском' },
          leave: { time: 'Сразу же, и ежедневно', what: 'подача и решение заявки на отпуск, и ежедневное напоминание, пока заявка ждёт согласования' },
          rest: { time: 'Каждые 3 дня в 14:00', what: 'сотрудник без выходного 14 дней подряд' },
          rosterDepartures: { time: 'Ежедневно 11:00', what: 'сотрудники, выезжающие на вахту через 7, 4 или 1 день' },
        },
        notScheduling:
          'Это время фиксированное и на этой странице не настраивается. После проверки письма уходят примерно за полминуты; что ушло на самом деле, видно на вкладке «Сообщения».',
        reach:
          'Каждое правило показывает, до кого доходит прямо сейчас. Нажмите на группу получателей, чтобы увидеть адреса. Янтарный цвет означает охват почти всей компании — уместно для дня рождения и стоит проверки во всём остальном.',
      },
      statusValue: { Pending: 'В очереди', Sending: 'Отправляется', Sent: 'Отправлено', Failed: 'Ошибка' },
    },
  },
}
